/**
 * Format a date string from the API (stored in UTC) to IST (Indian Standard Time).
 * Handles cases where the backend sends ISO strings without 'Z' suffix.
 */
export const formatDate = (dateStr, options = {}) => {
  if (!dateStr) return '-';
  
  // If the string doesn't end with Z or have timezone info, append Z (it's UTC from server)
  let normalized = dateStr;
  if (!dateStr.endsWith('Z') && !dateStr.includes('+') && !dateStr.includes('-', 10)) {
    normalized = dateStr + 'Z';
  }
  
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return dateStr;
  
  const formatted = date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    ...options
  });
  
  return `${formatted} IST`;
};

export const formatDateShort = (dateStr) => {
  if (!dateStr) return '-';
  
  let normalized = dateStr;
  if (!dateStr.endsWith('Z') && !dateStr.includes('+') && !dateStr.includes('-', 10)) {
    normalized = dateStr + 'Z';
  }
  
  const date = new Date(normalized);
  if (isNaN(date.getTime())) return dateStr;
  
  const formatted = date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
  
  return `${formatted} IST`;
};
